import { useState, useRef, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { redirectToSSOLogin } from '@/lib/sso'

export const UserAvatarMenu: React.FC = () => {
  const { user, isAuthenticated, logout } = useAuth()
  const [open, setOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  if (!isAuthenticated || !user) return null

  const initial = (user.display_name || user.email).charAt(0).toUpperCase()

  const handleLogout = async () => {
    setOpen(false)
    await logout()
  }

  const getAgentPortalUrl = () => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'https://localhost:5174'
    }
    return 'https://agent.hocnhe.com'
  }

  return (
    <div ref={menuRef} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 focus:outline-none"
      >
        {user.avatar ? (
          <img
            src={user.avatar}
            alt="Avatar"
            className="w-9 h-9 rounded-full object-cover border border-[#E65F00] shadow-sm"
          />
        ) : (
          <div className="w-9 h-9 bg-gradient-to-br from-pink-500 to-rose-500 rounded-full flex items-center justify-center border border-[#E65F00] shadow-sm">
            <span className="text-sm font-bold text-white">{initial}</span>
          </div>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50 animate-fadeIn">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-sm font-medium text-gray-900 truncate">
              {user.display_name || user.email}
            </p>
            <p className="text-xs text-gray-500 truncate">{user.email}</p>
          </div>

          <div className="py-1">
            <a
              href="https://sso.hocnhe.com"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              <Icon icon="ph:user-gear-bold" className="w-4 h-4" />
              Quản lý tài khoản
            </a>

            <a
              href={getAgentPortalUrl()}
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm font-bold text-[#E65F00] hover:bg-orange-50/50 transition-colors border-t border-gray-100/50 mt-1 pt-3"
            >
              <Icon icon="ph:handshake-bold" className="w-4.5 h-4.5 text-[#E65F00]" />
              Cổng Cộng tác viên
            </a>
          </div>

          <div className="border-t border-gray-100 py-1">
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors"
            >
              <Icon icon="ph:sign-out-bold" className="w-4 h-4" />
              Đăng xuất
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
